/* eslint-disable */
/**
 * Variables for Fonts and Colors used through out the app
 */

// Colors
export const color_black = '#000';
export const color_black_rgba = (opacity) => {
  const alpha = opacity ? opacity : 1;
  return 'rgba(0, 0, 0, ' + alpha + ' )';
};

export const color_grey = '#b6b5ba';
export const color_grey_rgba = (opacity) => {
  const alpha = opacity ? opacity : 1;
  return 'rgba(182, 181, 186, ' + alpha + ' )';
};

export const color_darkGrey = '#4A4A4A';
export const color_darkGrey_rgba = (opacity) => {
  const alpha = opacity ? opacity : 1;
  return 'rgba(74, 74, 74, ' + alpha + ' )';
};

export const color_white = '#FFF';
export const color_white_rgba = (opacity) => {
  const alpha = opacity ? opacity : 1;
  return 'rgba(255, 255, 255, ' + alpha + ' )';
};

export const color_orange = '#F56723';
export const color_orange_rgba = (opacity) => {
  const alpha = opacity ? opacity : 1;
  return 'rgba(245, 103, 35, ' + alpha + ' )';
};

export const color_blue = '#003698';
export const color_blue_rgba = (opacity) => {
  const alpha = opacity ? opacity : 1;
  return 'rgba(0, 54, 152, ' + alpha + ' )';
};

export const color_red = '#D0021B';
export const color_red_rgba = (opacity) => {
  const alpha = opacity ? opacity : 1;
  return 'rgba(208, 2, 27, ' + alpha + ' )';
};

/* eslint-enable */



/** WEBPACK FOOTER **
 ** ./src/css/vars.js
 **/